import React, { useEffect, useState } from "react";
import SearchContentBlock from "./Generic/SearchContentBlock";
import StockName from "./SearchStockChunks/StockName";
import di from "./di/servicelocator";
import { useNavigate } from "react-router-dom";
const OptionChainToolBlock = (props) => {
    const navigate = useNavigate();
    const [optionChainList, setOptionChainList] = useState();
    useEffect(() => {
        di.search
            .getOptionChainToolData({
            searchText: props.searchKey,
        })
            .then((data) => {
            setOptionChainList(data.optionChain);
        })
            .catch((err) => {
            setOptionChainList(undefined);
        });
    }, [props.searchKey]);
    return (
    // <div
    //   className={`option-search-block  pdt-20 ${
    //     device?.isDesktop ? "" : "pdlr-15"
    //   }`}
    // >
    //   <div className="searchdata-border-block">
    React.createElement(React.Fragment, null, (optionChainList === null || optionChainList === void 0 ? void 0 : optionChainList.length) > 0 &&
        (optionChainList === null || optionChainList === void 0 ? void 0 : optionChainList.map((x) => {
            return (React.createElement(SearchContentBlock, { topleft: React.createElement(StockName, { stockName: x.underlyingSymbolName }), topright: React.createElement("div", { onClick: () => {
                        navigate(`/option-chain-tool/${x.underlyingSymbolName}/${x.idx}`);
                        props.setSearchPopup(false);
                    }, className: "txt-underline" }, "Option Chain"), onSelected: () => {
                    props.setSearch(x.underlyingSymbolName);
                    props.setOptions(false);
                    props.setSelectedOptions(x);
                } }));
        })))
    //   </div>
    // </div>
    );
};
export default OptionChainToolBlock;
